import { AxiosResponse } from 'axios'
import { BaseResponseMapper } from './BaseMapper'
import { Utils } from '@/data/infrastructures/misc/Utils'
import { Pagination, Report, ReportData } from '@/domain/entities/Main'

export class MainMapper extends BaseResponseMapper {
  public convertReportListFromApi(result: AxiosResponse): ReportData {
    const {
      data: { data, meta },
    } = result

    return new ReportData({
      pagination: new Pagination(
        Utils.toInstance(new Map(), JSON.stringify(meta), 'camelCase') as any
      ),
      data: data?.map(
        (item: Record<string, any>) =>
          new Report(
            Utils.toInstance(
              new Map(),
              JSON.stringify(item),
              'camelCase'
            ) as any
          )
      ),
    })
  }
}
